// extracted by mini-css-extract-plugin
export default {"UnsavedFormMessage":"UnsavedFormDialog_UnsavedFormMessage__YTAil"};